/**
     * EngineRegistered.contract.ts — Event Contract System™ (generation v1).
     * An engine adapter registered with Roamer Core™ (boot or hot-attach).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const EngineRegisteredContract: EventContract = {
      name: 'EngineRegistered',
      version: 1,
      description: "An engine adapter registered with Roamer Core™ (boot or hot-attach).",
      publishers: ["core"],
      subscribers: ["plugin-registry"],
      fields: [
        { name: 'engineId', type: 'string', required: true, description: "Registered engine adapter id" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Registration time (now passed to registerEngine).",
      stability: 'stable',
      deprecated: false,
      example: {"engineId":"fusion"},
    };
    